// Simple version of product.js without Webpack
// index.js — simplified version without Webpack
function resetYMK($ymkModule) {
  console.log("resetYMK: Forcing YMK reinitialization");

  if (window.YMK) {
    try {
      window.YMK.close(); // Close the current session
    } catch (e) {
      console.log("YMK close failed:", e);
    }

    // Clear any internal state or UI flags
    document.body.classList.remove('try-it-on-engine-active');
    document.body.classList.remove('try-it-on-open');
    document.body.classList.remove('try-it-on-initialized');

    // Optionally, remove and re-add the module DOM if needed
    // $ymkModule.innerHTML = ''; // Clear the module container

    // Re-initialize YMK
    setTimeout(() => {
      window.YMK.init({
        autoOpen: true,
        width: $ymkModule.offsetWidth,
        height: $ymkModule.offsetHeight
      });
      document.body.classList.add('try-it-on-initialized');
      console.log("YMK reinitialized");
    }, 100); // Small delay to allow cleanup
  }
}
function insertScriptNode(d, k) {
  var s = d.createElement('script');
  s.type = 'text/javascript';
  s.defer = true;
  s.src = 'https://plugins-media.perfectcorp.com/c28445-dev/sdk.js?apiKey=' + k;
  var x = d.getElementsByTagName('script')[0];
  x.parentNode.insertBefore(s, x);

  (function (d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s);
    js.id = id;
    js.src = 'https://connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'facebook-jssdk');
}

function adjustModuleSize($ymkModule) {
  var newHeight;
  console.log(window.innerWidth)
  if (window.innerWidth < 1024) {
    newHeight = document.querySelector('.product__media-gallery-viewer').offsetHeight;
  } else {
    newHeight = document.querySelector('.product__media-gallery-viewer').offsetHeight;
  }
 console.log(newHeight);
  $ymkModule.style.height = newHeight + 'px';
}

// Adjust swatches on mobile view
function adjustMobileSwatches($ymkModule) {
  if (window.innerWidth < 1024) {
    var swatchPosition = jQuery('.product__media-gallery-viewer').height() + 4;
    jQuery('ul.swatches.color').css('top', swatchPosition + 'px');

    var swatchMinHeight =
      jQuery('.product__title').height() +
      jQuery('.product__block--price').height() +
      20;
    jQuery('ul.swatches.color').css('min-height', swatchMinHeight + 'px');
  }
}


function clearLabels() {
  document.querySelectorAll('.try-it-on-selected-value').forEach(function (el) {
    el.querySelector('.try-it-on-value').textContent = el.dataset.labelNone;
  });
}

function changeLabel(makeupType, displayValue) {
  var el = document.querySelector(`.try-it-on-selected-value[data-makeup-id="${makeupType}"] .try-it-on-value`);
  if (el) el.textContent = displayValue;
}

function onModuleOpened() {
  clearLabels();
  document.body.classList.add('try-it-on-open');
  document.querySelector('.try-it-on-promo')?.classList.add('visible');
  document.querySelector('.try-it-on-start')?.setAttribute('disabled', true);
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function onEngineOpened() {
  console.log("onEngineOpened");
  document.body.classList.add('try-it-on-engine-active');
  applyMakeupAuto();
  adjustMobileSwatches(document.getElementById('YMK-module'));

}

function onEngineClosed() {
  console.log("onEngineClosed");
  resetYMK($ymkModule);
  document.body.classList.remove('try-it-on-engine-active');
  document.body.classList.remove('try-it-on-open');
}

function onModuleClosed() {
   console.log("onModuleClosed");
  document.body.classList.remove('try-it-on-open');
  document.body.classList.remove('try-it-on-engine-active');
  document.querySelector('.try-it-on-start')?.removeAttribute('disabled');
}

function initYMK($ymkModule) {
  console.log("initYMK");
  window.ymkAsyncInit = function () {
    window.YMK.addEventListener('opened', onModuleOpened);
    window.YMK.addEventListener('loaded', onEngineOpened);
    window.YMK.addEventListener('engineClosed', onEngineClosed);
    window.YMK.addEventListener('closed', onModuleClosed);
  };
}

function isOpen() {
  return document.body.classList.contains('try-it-on-open');
}

function isInitialized() {
  console.log("isInitialized");
  return document.body.classList.contains('try-it-on-initialized');
}

function startEngine(initialized) {
  //  alert("heree");
  var $ymkModule = document.getElementById('YMK-module');
  if (initialized) {
    window.YMK.open();
    console.log("initialized open");
    document.body.classList.add('try-it-on-initialized');
    const interval = setInterval(() => {
        const iframe = document.querySelector("#YMK-module iframe");

        if (iframe) {
          iframe.onload = () => {
          clearInterval(interval);

          const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

          const style = iframeDoc.createElement("style");
          style.id = "custom-style";
          style.textContent = `
          `;
          iframeDoc.head.prepend(style);
          }
        }
      }, 500);
  } else {
    console.log("initialized alreadyopen");
    document.body.classList.add('try-it-on-initialized');
    const interval = setInterval(() => {
        const iframe = document.querySelector("#YMK-module iframe");

        if (iframe) {
          iframe.onload = () => {
          clearInterval(interval);

          const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

          const style = iframeDoc.createElement("style");
          style.id = "custom-style";
          style.textContent = `
          `;
          iframeDoc.head.prepend(style);
          }
        }
      }, 500);
    document.body.classList.add('try-it-on-initialized');
    adjustModuleSize($ymkModule);
    window.YMK.init({
      autoOpen: true,
      width: $ymkModule.offsetWidth,
      height: $ymkModule.offsetHeight
    });
  }
  applyMakeupAuto();
}

function closeEngine() {
  window.YMK.close();
}

function applyMakeup($swatch) {
  if (jQuery('body').hasClass('try-it-on-engine-active')) {
    var makeupType = jQuery('[name="try-it-on-option"]:checked').data('makeup-id');
    var makeupGUID = $swatch.data('makeup-guid-' + makeupType);
    window.YMK.applyMakeupBySku(makeupGUID);
    changeLabel(makeupType, $swatch.data('display-value'));
  }
}

function applyMakeupAuto() {
  if (jQuery('body').hasClass('try-it-on-engine-active')) {
    var makeupType = jQuery('[name="try-it-on-option"]:checked').attr('data-makeup-id');
    var variant = jQuery(".original-selector").val();
    var makeupGUID = jQuery('.try-on-original-selector .try-it-on-swatch.try-val-'+variant+' label').attr('data-makeup-guid-'+makeupType);
    window.YMK.applyMakeupBySku(makeupGUID);
  }
}

function filterAvailableType() {
    document.querySelectorAll('.try-it-on-swatch label').forEach(sw => {
      [
        'eyebrows', 'eyeliner', 'eyes', 'cheeks', 'face', 'lips', 'mascara'
      ].forEach(type => {
        if (sw.dataset[`makeupGuid${type.charAt(0).toUpperCase() + type.slice(1)}`] !== '') {
          document.querySelector(`div[data-makeup-id="${type}"]`)?.removeAttribute('style');
          document.querySelector('[name="try-it-on-option"][data-makeup-id="'+type+'"]').checked = true;
          document.querySelector(`.option-makeup-${type}`)?.removeAttribute('style');
        }
      });
    });
  }

// --- MAIN EXECUTION ---

(function () {
  var $ymkModule = document.getElementById('YMK-module');
  var windowWidth = window.innerWidth;

  if (document.querySelector('.try-it-on-auto')) {
    document.body.classList.add('try-it-on-auto-flag');
  }

  initYMK($ymkModule);
  insertScriptNode(document, '7WDwQSWAhdsyY5KdNvvKrA');

   if (document.querySelector('.try-it-on-btn button')) {
      filterAvailableType();
    }


  window.addEventListener('resize', function () {
    if (window.innerWidth !== windowWidth) {
      windowWidth = window.innerWidth;
      if (isInitialized()) {
        closeEngine();
        onEngineClosed();
        adjustModuleSize($ymkModule);
        startEngine(false); // Force restart
      } else {
        document.body.classList.add('try-it-on-resized');
      }
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.matches('.try-it-on-start span')) {
      e.preventDefault();
      if (document.body.classList.contains('try-it-on-resized')) {
        document.body.classList.remove('try-it-on-resized');
        startEngine(false);
      } else {
        startEngine(isInitialized());
      }
    }
    if (e.target.matches('.try-it-on-start')) {
      e.preventDefault();
      if (document.body.classList.contains('try-it-on-resized')) {
        document.body.classList.remove('try-it-on-resized');
        startEngine(false);
      } else {
        startEngine(isInitialized());
      }
    }

    if (e.target.matches('.try-it-on-makeup')) {
      e.preventDefault();
      var makeupID = e.target.dataset.makeupId;
      window.YMK.applyMakeupBySku(makeupID);
    }

    if (e.target.matches('.try-it-on-clear')) {
      e.preventDefault();
      clearLabels();
      window.YMK.reset();
    }

    if (e.target.matches('.try-it-on-close')) {
      e.preventDefault();
      closeEngine();
    }

    if (e.target.matches('.try-it-on-apply')) {
      e.preventDefault();
      applyMakeupAuto();
    }
  });

  document.body.addEventListener('change', function (e) {
    if (e.target.closest('.try-it-on-option input')) {
      applyMakeupAuto();
    }
  });
})();


document.addEventListener('DOMContentLoaded', function() {
  // Ensure both modules are defined before calling them
  if (typeof window.TryItOn === 'function') {
    window.TryItOn();
  }

  if (typeof window.ProductEvents === 'function') {
    window.ProductEvents();
  }
});


(function() {
  // Check if TryItOn module is available globally
  // e.g. window.TryItOn should be defined elsewhere
  var TryItOn = window.TryItOn || null;

  var $pdpMain = document.querySelector('.try-it-on-swatch');
console.log($pdpMain);
  if ($pdpMain && TryItOn) {
    $pdpMain.addEventListener('click', function(e) {
      var swatch = e.target;
      console.log(swatch);
      if (swatch && TryItOn.isOpen()) {
        var label = swatch.querySelector('label');
        applyMakeup(label);
      }
    });
  }
jQuery("body").on('click', '.try-it-on-swatch', function (e) {
   // e.preventDefault();
     var TryItOn = window.TryItOn || null;
if(document.body.classList.contains('try-it-on-open')) {
        var label = jQuery(this).find('label');
        applyMakeup(label);
      }
  });

  document.addEventListener('variant:changed', function(evt) {
    // console.log(evt.detail.variant);
 
    var value_try =  evt.detail.variant.id;
    jQuery(".original-selector").val(value_try).trigger("change");
    jQuery(".try-it-on-swatch.try-val-"+value_try).trigger('click');
  });

})();




